import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import Landscape from '../../assets/customSVG/Landscape';

const OrderStatusTemplate = ({
  data = {},
  message = {},
  settings = {},
}) => {

  // Extract data from message template
  const body = message?.template?.find(item => item.type === 'BODY')?.text || '';
  const footer = message?.template?.find(item => item.type === 'FOOTER')?.text || '';
  const order_status = settings?.payment_status || 'PENDING';
  const total = settings?.total ? ` ₹${(settings.total / 100).toFixed(2)}` : 'N/A';
  const ProducNames = settings?.products?.map(product => product.name).join(', ') || [];
  const quantity = settings?.quantity || 1;
  const productImage = settings?.products?.[0]?.image_url || '';



  return (
    <div className="w-full max-w-sm">
      {/* Payment details */}
      <div className='flex flex-row gap-2 items-center justify-between bg-[#f4f6f8] p-1 rounded-md'>
        <div>
          <span className="text-gray-600 text-sm">{ProducNames}</span>
          <div className='flex gap-2'>
            <span className="text-gray-600 text-sm">Quantity: {quantity}</span>
            <span className="text-gray-600 text-sm">{total}</span>
          </div>
        </div>
        <div className='w-12 h-12 rounded-lg'>
          <img src={productImage} alt="Product" className="w-12 h-12" />
        </div>
      </div>

      {/* Status */}
      {order_status === 'COMPLETED' && (
        <div>
          <span className="text-gray-600 text-sm">Status: Order Complete</span>
        </div>
      )}
      {order_status === 'PENDING' && (
        <div>
          <span className="text-gray-600 text-sm">Status: Order Pending</span>
        </div>
      )}
      {order_status === 'FAILED' && (
        <div>
          <span className="text-gray-600 text-sm">Status: Order Failed</span>
        </div>
      )}

      {/* body */}
      {body && (
          <div
            className={`new-body-text break-words w-100`}
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          ></div>
        )}

      {/* Footer */}
      {footer && (
        <div className="text-[#9CA3AF] mt-[0.5vw] text-xs">
          {footer}
        </div>
      )}

      {data?.status === "BOUNCED" && (
        <Tooltip title={JSON.stringify(data?.error_notes)}>
          <div className="flex-row align-center justify-end gap-1 text-[0.8rem] cursor-pointer font-[500] text-[#FF543E] ptb-5">
            <img src={ICONS?.inboxBounced} alt="" />
            Unable to send the message!
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default OrderStatusTemplate;